import { Injectable } from '@angular/core';
import { OrigamiResponse, ServiceBase } from './base/service.base';
import { Observable } from 'rxjs';
import { ErrorCode } from '../constants/error-codes';
import { ErrorRecord } from '@app/origami-api/utils/error-utils';

export interface JobManagementModel {
  Action: string;
  ErrorCode: number;
  ErrorMessage: string;
  ErrorRecords: ErrorRecord[];
  ErrorRecordsTotalCount: number;
  JobId: string;
  PositionInQueue: number;
  ProgressCurrent: number;
  ProgressTotal: number;
  Result: string;
  Status: string;
}

@Injectable()
export class JobManagementService extends ServiceBase {
  serviceUrl = 'JobManagementService.svc';

  getJobsResult(siteId: number, jobIds: string[]): Observable<OrigamiResponse<JobManagementModel[]>> {
    return this.origamiPost('/GetJobsResult', { siteId, jobIds }, null, null, true);
  }

  getJobResult(
    siteId: number,
    jobId: string,
    silentErrorCodes?: ErrorCode[],
  ): Observable<OrigamiResponse<JobManagementModel>> {
    return this.origamiPost('/GetJobResult', { siteId, jobId }, null, silentErrorCodes, true);
  }

  cancelJob(siteId: number, jobId: string): Observable<OrigamiResponse<JobManagementModel>> {
    return this.origamiPost('/CancelJob', { siteId, jobId }, null, null, true);
  }
}
